import * as Yup from "yup";

export const exchangeCreateSchema = Yup.object().shape({
  exchangeName: Yup.string().trim().required("exchange name is required"),
  displayOrder: Yup.number().required("display Order is required"),
  via: Yup.object().required("Select Any via"),
});
